import { render, staticRenderFns } from "./vue-qz-tray-printers.vue?vue&type=template&id=673e29b7&scoped=true&"
import script from "./vue-qz-tray-printers.vue?vue&type=script&lang=js&"
export * from "./vue-qz-tray-printers.vue?vue&type=script&lang=js&"
import style0 from "./vue-qz-tray-printers.vue?vue&type=style&index=0&id=673e29b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673e29b7",
  null
  
)

export default component.exports